import Entity from './entity'

const ClientPayment = new Entity('clientpayments')

export default ClientPayment
